import {
	Directive,
	ElementRef,
	Input,
	OnChanges
} from '@angular/core';

import { debounce } from 'underscore';

import { VgStates } from './videogular/VgStates';

/**
 * Workaround for ng-class being unreliable, displaying the incorrect classes on the element. Sometimes it would even have 2 states simultaneously.
 */
@Directive({
	selector: '[current-state-class]',
	standalone: false
})
export class CurrentStateClassDirective implements OnChanges {
	@Input() public currentState: VgStates;
	@Input() public isLive: boolean;

	private onChangeDebounced = debounce(() => this.onChange(), 1000);

	constructor(
		private elRef: ElementRef<HTMLElement>
	) {}

	public ngOnChanges(): void {
		this.onChangeDebounced();
	}

	private onChange(): void {
		const isPlay: boolean = this.isLive ?
			this.currentState !== VgStates.STOP :
			this.currentState === VgStates.PLAY;
		const isNotPlaying: boolean = !isPlay;

		const element = this.elRef.nativeElement;

		element.classList.toggle(VgStates.PLAY, isPlay);
		element.classList.toggle(VgStates.PAUSE, isNotPlaying && !this.isLive);
		element.classList.toggle(VgStates.STOP, isNotPlaying && this.isLive);
		element.classList.toggle('is-not-playing', isNotPlaying);
	}
}
